import "./Tela05.styles.css";

import { useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

import bannerIted from "../../img/imgsTela5/bannerIted.svg";
import bannerInovae from "../../img/imgsTela5/bannerInovae.png";
import bgTl5 from "../../img/imgsTela5/bgTl5.png";


export default function Tela5(){

    const banners = [
        { id: 1, imagem: bannerIted, alt: "Banner ITED 1" },
        { id: 2, imagem: bannerInovae, alt: "Banner INOVAE " },
        { id: 3, imagem: bannerIted, alt: "Banner ITED 3" },
        { id: 4, imagem: bannerInovae, alt: "Banner INOVAE 4 " },
    ];

    const [bannerAtual, setBannerAtual] = useState(0);

    const proximoBanner = () => {
        setBannerAtual((prev) => (prev + 1) % banners.length);
    };

    const bannerAnterior = () => {
        setBannerAtual((prev) => (prev - 1 + banners.length) % banners.length);
    };

    useEffect(() => {
        const intervalo = setInterval(() => {
        setBannerAtual((prev) => (prev + 1) % banners.length);
        }, 5000);

        return () => clearInterval(intervalo);
    }, [banners.length]);

return (
    <section
      className="tela05"
      style={{ backgroundImage: `url(${bgTl5})` }}
    >
      <div className="tela05__container">

        <div className="tela05__bannerArea" >
          <button
            className="tela05__sideArrow tela05__sideArrow--left"
            onClick={bannerAnterior}
            aria-label="Banner anterior"
          >
            <IoIosArrowBack />
          </button>

          <div className="tela05__slider">
            <div
              className="tela05__track"
              style={{ transform: `translateX(-${bannerAtual * 100}%)` }}
            >
              {banners.map((banner) => (
                <div className="tela05__slide" key={banner.id}>
                  <img
                    src={banner.imagem}
                    alt={banner.alt}
                    className="tela05__banner"
                  />
                </div>
              ))}
            </div>
          </div>

          <button
            className="tela05__sideArrow tela05__sideArrow--right"
            onClick={proximoBanner}
            aria-label="Próximo banner"
          >
            <IoIosArrowForward />
          </button>
        </div>
      </div>
    </section>
  );


}